import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { type CSSProperties } from 'react'
import { makeTextFieldClear, makeTextFieldIcon, TextField } from 'shared/ui/TextField'
import styles from './styles.module.scss'

type ITableSearchProps = {
  value: string
  className?: string
  onChange: (value: string) => void
  marginIcon?: CSSProperties['margin']
}

export const TableSearch = observer(
  ({ value, className, onChange, marginIcon = '7px' }: ITableSearchProps) => {
    return (
      <TextField
        className={classNames(styles.textField, className)}
        size={'medium'}
        onChange={onChange}
        variant={'integrated'}
        value={value}
        InputProps={{
          placeholder: 'Search...',
          className: styles.search,
        }}
        leftActions={[
          makeTextFieldIcon({
            icon: 'search',
            fontSize: 18,
            color: 'var(--content-primary-tertiary)',
            margin: marginIcon,
          }),
        ]}
        rightActions={[
          makeTextFieldClear({
            isButton: true,
            isVisibleWithoutFocus: true,
            color: 'var(--content-primary-secondary)',
          }),
        ]}
      />
    )
  }
)
